import GridItem from './GridItem'

export default GridItem



// WEBPACK FOOTER //
// ./src/components/GridItem/index.js